import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { ReportSubmitPage } from "../report-submit/report-submit";

@Component({
  selector: 'page-report-approve-photo',
  templateUrl: 'report-approve-photo.html',
})
export class ReportApprovePhotoPage {

  record: any;
  index = 0;
  parent: ReportSubmitPage;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public viewCtrl: ViewController
  ) {
    this.record = navParams.get('record');
    this.index = navParams.get('index');
    this.parent = navParams.get('parent');
  }

  removePhoto(){
    if(!this.record.unit.photos[this.record.index]._approved){
      this.parent.newPhotosUnapproved--;
    }
    // Remove photo from unit
    this.record.unit.photos.splice(this.record.index, 1);
    // Remove photo from newPhotos
    this.parent.newPhotos.splice(this.index, 1);
    this.closeModal();
  }

  approvePhoto(){
    if(!this.record.unit.photos[this.record.index]._approved){
      this.record.unit.photos[this.record.index]._approved = true;
      this.parent.newPhotosUnapproved--;
    }
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-approve-photo/report-approve-photo.ts